module.exports = __webpack_public_path__ + "static/media/ig10.af0eadd1.jpg";